angular.module('picmonic-common').factory('CarouselModal', [
    '$modal',
    function ($modal) {
        return {
            showModal: function (images, index) {
                const slides = images.map((img, key) => ({
                    image: img,
                    active: index === key,
                }));

                $modal.open({
                    templateUrl: '/templates/app/factories/carousel-modal/carousel-modal.html',
                    windowClass: 'carousel-modal',
                    size: 'lg',
                    backdrop: 'static',
                    backdropClass: 'above-nav',
                    controller: [
                        '$scope',
                        function ($scope) {
                            $scope.images = slides;
                        },
                    ],
                });
            },
        };
    },
]);
